
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/carrot-ads",
      function () {
        return require("private-next-pages/destinations/carrot-ads.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/carrot-ads"])
      });
    }
  